import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { getFeatures } from './featuresModule';
import useFeatureActions from './useFeatureActions';

export default function useFeatures(inputHandles, options) {
  const actions = useFeatureActions();
  const features = useSelector((state) => getFeatures(state, inputHandles));

  useEffect(() => {
    if (inputHandles && inputHandles?.length) {
      actions.loadFeatures(inputHandles, options);
    }
  });

  return features;
}
